import { FlatCheckIcon } from '../../icons';
import { bulkDraftMissingRequired, bulkDraftReady, getBulkCheckState } from '../../groupings';

function photoSourceNote(c) {
    if (!c || c.photos === 0) return 'Encouraged but not required to submit.';
    if (c.photoSource === 'mixed') {
        return `${c.photos} photo(s) · AI + host`;
    }
    if (c.photoSource === 'ai') {
        return `${c.photos} AI-sourced photo(s). Add host photos via Bulk Add Photos if desired.`;
    }
    return `${c.photos} photo(s) attached.`;
}

function checklistRow(label, done, required, note) {
    const cls = done ? 'done' : (required ? 'todo' : 'optional');
    const icon = done ? '✓' : (required ? '⬚' : '○');
    return (
        <div className={`bulk-checklist-row ${cls}`} key={label}>
            <span className="bulk-checklist-icon">{icon}</span>
            <span className="bulk-checklist-label">
                {label}
                {required && !done && <span className="required">required</span>}
                {!required && <span className="optional-tag">optional</span>}
            </span>
            <span className="bulk-checklist-note">{note}</span>
        </div>
    );
}

export default function BulkChecklist({ listing }) {
    const ready = bulkDraftReady(listing);
    const c = getBulkCheckState(listing);
    const missing = bulkDraftMissingRequired(listing);

    return (
        <div className="host-panel-section">
            <div className="bulk-checklist">
                <div className="bulk-checklist-head">
                    <div className="bulk-checklist-title">
                        {ready ? (
                            <>
                                <FlatCheckIcon /> Ready to submit
                            </>
                        ) : 'Complete these items to submit'}
                    </div>
                    <div className="bulk-checklist-meta">
                        From bulk CSV upload
                    </div>
                </div>
                <div className="bulk-checklist-rows">
                    {missing.length > 0 && checklistRow(
                        'Required fields missing',
                        false,
                        true,
                        `${missing.join(', ')} not provided in the CSV — use Complete draft to set them.`,
                    )}
                    {checklistRow(
                        'Geofence reviewed',
                        c.geofenceReviewed,
                        true,
                        'Review the geofence section below to confirm the AI-proposed polygon.',
                    )}
                    {checklistRow(
                        'AI fields confirmed',
                        c.aiPending === 0,
                        true,
                        c.aiPending > 0
                            ? `${c.aiPending} medium/low-confidence fields still need a confirm or edit.`
                            : 'All AI fields confirmed.',
                    )}
                    {checklistRow(
                        'Photos uploaded',
                        c.photos > 0,
                        false,
                        photoSourceNote(c),
                    )}
                    {checklistRow(
                        'Additionally insured',
                        c.insuranceAddressed,
                        true,
                        c.insuranceAddressed
                            ? 'Additionally insured confirmed for this property.'
                            : 'Select Yes or No, then provide the endorsement if required.',
                    )}
                </div>
            </div>
        </div>
    );
}
